import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Sidebar from './sidebar';

const SubscribeList = () => {
    const navigate = useNavigate();
    const [subscribers, setSubscribers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // Pagination states
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(5);
    const [totalPages, setTotalPages] = useState(0);

    useEffect(() => {
        const adminVerified = localStorage.getItem('adminVerified');
        console.log("adminVerified", adminVerified);
        if (adminVerified != 'true') {
            navigate('/');
        }
        fetchList();
    }, [navigate]);

    const fetchList = async () => {
        setLoading(true);
        try {
            const response = await axios.post(process.env.REACT_APP_API_URL, {
                apikey: process.env.REACT_APP_API_KEY,
                module: "admin",
                method: "subscribeCollection",
            });

            const jsonData = JSON.parse(response.data.body);
            console.log("jsonData");
            console.log(jsonData);
            if (jsonData.status === "success") {
                console.log("--------------");
                console.log(jsonData.result.subscriptions);
                const fetchedSubscribers = jsonData.result.subscriptions || [];
                setSubscribers(fetchedSubscribers);
                setTotalPages(Math.ceil(fetchedSubscribers.length / itemsPerPage));
            } else {
                setError("Failed to fetch subscribers");
                console.log("Failed to fetch subscribers");
            }
        } catch (error) {
            setError("Error fetching subscribers: " + error.message);
            console.log("Error fetching subscribers: " + error.message);
        } finally {
            setLoading(false);
            console.log(false);
        }
    };

    const getStatusBadgeClass = (status) => {
        switch (status?.toLowerCase()) {
            case 'active':
                return 'status-badge status-active';
            case 'inactive':
                return 'status-badge status-inactive';
            case 'pending':
                return 'status-badge status-pending';
            default:
                return 'status-badge';
        }
    };

    // Format date to be more readable
    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        });
    };

    // Pagination handlers
    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleItemsPerPageChange = (e) => {
        const newItemsPerPage = parseInt(e.target.value, 10);
        setItemsPerPage(newItemsPerPage);
        setTotalPages(Math.ceil(subscribers.length / newItemsPerPage));
        setCurrentPage(1); // Reset to first page when changing items per page
    };

    // Get current page items
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = subscribers.slice(indexOfFirstItem, indexOfLastItem);

    // Generate page numbers
    const pageNumbers = [];
    for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
    }

    return (
        <div className="dashboard-container">
            <Sidebar />
            <div className="content-area">
                <div className="page-header">
                    <h1>Subscribers List</h1>
                    {/* <button className="refresh-btn" onClick={fetchList}>
                        Refresh
                    </button> */}
                </div>

                {loading ? (
                    <div className="loading-container">
                        <div className="loader"></div>
                        <p>Loading subscribers...</p>
                    </div>
                ) : error ? (
                    <div className="error-message">
                        <p>{error}</p>
                        <button onClick={fetchList}>Try Again</button>
                    </div>
                ) : (
                    <>
                        <div className="pagination-controls">
                            <div className="items-per-page">
                                <label htmlFor="itemsPerPage">Show: </label>
                                <select
                                    id="itemsPerPage"
                                    value={itemsPerPage}
                                    onChange={handleItemsPerPageChange}
                                >
                                    <option value="5">5</option>
                                    <option value="10">10</option>
                                    <option value="25">25</option>
                                    <option value="50">50</option>
                                </select>
                                <span> entries</span>
                            </div>
                            <div className="showing-info">
                                Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, subscribers.length)} of {subscribers.length} entries
                            </div>
                        </div>

                        <div className="table-container">
                            <table className="subscribers-table">
                                <thead>
                                    <tr>
                                        <th>S.No</th>
                                        <th>Email</th>
                                        <th>Status</th>
                                        <th>Date</th>
                                        {/* <th>Actions</th> */}
                                    </tr>
                                </thead>
                                <tbody>
                                    {currentItems.length > 0 ? (
                                        currentItems.map((subscriber, index) => (
                                            <tr key={subscriber._id || index}>
                                                <td>{indexOfFirstItem + index + 1}</td>
                                                <td>{subscriber.mailaddress}</td>
                                                <td>
                                                    <span className={getStatusBadgeClass(subscriber.subscriptionStatus)}>
                                                        {subscriber.subscriptionStatus || 'Unknown'}
                                                    </span>
                                                </td>
                                                <td>{formatDate(subscriber.subscriptionDate)}</td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="5" className="no-data">No subscribers found</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>

                        <div className="pagination">
                            <button
                                onClick={() => handlePageChange(currentPage - 1)}
                                disabled={currentPage === 1}
                                className="page-btn prev-btn"
                            >
                                Previous
                            </button>
                            {pageNumbers.map(number => (
                                <button
                                    key={number}
                                    onClick={() => handlePageChange(number)}
                                    className={`page-btn ${currentPage === number ? 'active' : ''}`}
                                >
                                    {number}
                                </button>
                            ))}
                            <button
                                onClick={() => handlePageChange(currentPage + 1)}
                                disabled={currentPage === totalPages}
                                className="page-btn next-btn"
                            >
                                Next
                            </button>
                        </div>

                        <div className="subscribers-grid">
                            {currentItems.length > 0 ? (
                                currentItems.map((subscriber, index) => (
                                    <div className="subscriber-card" key={subscriber._id || index}>
                                        <div className="card-header">
                                            <span className="subscriber-number">#{indexOfFirstItem + index + 1}</span>
                                            <span className={getStatusBadgeClass(subscriber.subscriptionStatus)}>
                                                {subscriber.subscriptionStatus || 'Unknown'}
                                            </span>
                                        </div>
                                        <div className="card-body">
                                            <p className="subscriber-email">{subscriber.mailaddress}</p>
                                            <p className="subscriber-date">Joined: {formatDate(subscriber.subscriptionDate)}</p>
                                        </div>
                                        <div className="card-footer">
                                            <button className="action-btn view-btn">View</button>
                                            <button className="action-btn edit-btn">Edit</button>
                                            <button className="action-btn delete-btn">Delete</button>
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <div className="no-data-card">No subscribers found</div>
                            )}

                            <div className="mobile-pagination">
                                <button
                                    onClick={() => handlePageChange(currentPage - 1)}
                                    disabled={currentPage === 1}
                                    className="page-btn prev-btn"
                                >
                                    Previous
                                </button>
                                <span className="page-info">{currentPage} of {totalPages}</span>
                                <button
                                    onClick={() => handlePageChange(currentPage + 1)}
                                    disabled={currentPage === totalPages}
                                    className="page-btn next-btn"
                                >
                                    Next
                                </button>
                            </div>
                        </div>
                    </>
                )}
            </div>

            <style jsx>{`
                .dashboard-container {
                    display: flex;
                    min-height: 100vh;
                    background-color: #f5f7fa;
                    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
                }

                .content-area {
                    flex: 1;
                    padding-left: 316px;
                    padding-top: 69px;
                    overflow-x: hidden;
                }
                    @media (max-width: 768px) {
                .content-area {
                    flex: 1;
                    padding-left: 56px;
                    padding-top: 69px;
                    overflow-x: hidden;
                }
                
                
               }

                .page-header {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin-bottom: 20px;
                    padding-bottom: 10px;
                    border-bottom: 1px solid #e0e0e0;
                }

                .page-header h1 {
                    font-size: 24px;
                    color: #333;
                    margin: 0;
                }

                .refresh-btn {
                    background-color: #4a6cf7;
                    color: white;
                    border: none;
                    padding: 8px 16px;
                    border-radius: 4px;
                    cursor: pointer;
                    font-size: 14px;
                    transition: background-color 0.3s;
                }

                .refresh-btn:hover {
                    background-color: #3a57e8;
                }

                .loading-container {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    height: 200px;
                }

                .loader {
                    border: 4px solid #f3f3f3;
                    border-top: 4px solid #4a6cf7;
                    border-radius: 50%;
                    width: 40px;
                    height: 40px;
                    animation: spin 1s linear infinite;
                    margin-bottom: 16px;
                }

                @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }

                .error-message {
                    background-color: #ffebee;
                    color: #d32f2f;
                    padding: 16px;
                    border-radius: 8px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                }

                .error-message button {
                    background-color: #d32f2f;
                    color: white;
                    border: none;
                    padding: 8px 16px;
                    border-radius: 4px;
                    margin-top: 12px;
                    cursor: pointer;
                }

                /* Pagination Controls */
                .pagination-controls {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin-bottom: 16px;
                }

                .items-per-page select {
                    margin: 0 8px;
                    padding: 4px 8px;
                    border-radius: 4px;
                    border: 1px solid #ddd;
                }

                .showing-info {
                    font-size: 14px;
                    color: #666;
                }

                /* Table view (default for desktop) */
                .table-container {
                    background: white;
                    border-radius: 8px;
                    overflow: hidden;
                    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
                    margin-bottom: 24px;
                }

                .subscribers-table {
                    width: 100%;
                    border-collapse: collapse;
                }

                .subscribers-table th,
                .subscribers-table td {
                    padding: 12px 16px;
                    text-align: left;
                    border-bottom: 1px solid #f0f0f0;
                }

                .subscribers-table th {
                    background-color: #f9fafc;
                    font-weight: 600;
                    color: #555;
                }

                .subscribers-table tr:last-child td {
                    border-bottom: none;
                }

                .status-badge {
                    display: inline-block;
                    padding: 4px 12px;
                    border-radius: 20px;
                    font-size: 12px;
                    font-weight: 500;
                    text-transform: capitalize;
                }

                .status-active {
                    background-color: #e9f7ef;
                    color: #27ae60;
                }

                .status-inactive {
                    background-color: #fdedec;
                    color: #e74c3c;
                }

                .status-pending {
                    background-color: #fef9e7;
                    color: #f39c12;
                }

                .actions-cell {
                    white-space: nowrap;
                }

                .action-btn {
                    padding: 6px 12px;
                    border: none;
                    border-radius: 4px;
                    margin-right: 8px;
                    cursor: pointer;
                    font-size: 12px;
                    font-weight: 500;
                    transition: background-color 0.3s;
                }

                .view-btn {
                    background-color: #e3f2fd;
                    color: #2196f3;
                }

                .view-btn:hover {
                    background-color: #bbdefb;
                }

                .edit-btn {
                    background-color: #e8f5e9;
                    color: #4caf50;
                }

                .edit-btn:hover {
                    background-color: #c8e6c9;
                }

                .delete-btn {
                    background-color: #ffebee;
                    color: #f44336;
                }

                .delete-btn:hover {
                    background-color: #ffcdd2;
                }

                .no-data {
                    text-align: center;
                    padding: 32px;
                    color: #777;
                }

                /* Pagination */
                .pagination {
                    display: flex;
                    justify-content: center;
                    margin-top: 20px;
                    margin-bottom: 20px;
                }

                .page-btn {
                    padding: 8px 12px;
                    margin: 0 4px;
                    background-color: white;
                    border: 1px solid #ddd;
                    border-radius: 4px;
                    cursor: pointer;
                    transition: all 0.3s;
                }

                .page-btn.active {
                    background-color: #4a6cf7;
                    color: white;
                    border-color: #4a6cf7;
                }

                .page-btn:hover:not(:disabled):not(.active) {
                    background-color: #f5f5f5;
                }

                .page-btn:disabled {
                    opacity: 0.5;
                    cursor: not-allowed;
                }

                .prev-btn, .next-btn {
                    font-weight: 600;
                }

                /* Grid view (for mobile) */
                .subscribers-grid {
                    display: none;
                    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
                    gap: 16px;
                }

                .subscriber-card {
                    background: white;
                    border-radius: 8px;
                    overflow: hidden;
                    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
                }

                .card-header {
                    padding: 12px 16px;
                    background-color: #f9fafc;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    border-bottom: 1px solid #f0f0f0;
                }

                .subscriber-number {
                    font-weight: 600;
                    color: #555;
                }

                .card-body {
                    padding: 16px;
                }

                .subscriber-email {
                    font-weight: 500;
                    margin-bottom: 8px;
                    word-break: break-all;
                }

                .subscriber-date {
                    font-size: 13px;
                    color: #777;
                }

                .card-footer {
                    padding: 12px 16px;
                    background-color: #f9fafc;
                    display: flex;
                    justify-content: space-between;
                    border-top: 1px solid #f0f0f0;
                }

                .card-footer .action-btn {
                    flex: 1;
                    margin: 0 4px;
                    text-align: center;
                }

                .no-data-card {
                    grid-column: 1 / -1;
                    background: white;
                    padding: 32px;
                    text-align: center;
                    color: #777;
                    border-radius: 8px;
                    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
                }

                .mobile-pagination {
                    grid-column: 1 / -1;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    background: white;
                    padding: 12px;
                    margin-top: 16px;
                    border-radius: 8px;
                    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
                }

                .page-info {
                    font-size: 14px;
                    color: #666;
                }

                /* Media query for responsive design */
                @media (max-width: 768px) {
                    .table-container, .pagination {
                        display: none;
                    }

                    .subscribers-grid {
                        display: grid;
                    }

                    .page-header {
                        flex-direction: column;
                        align-items: flex-start;
                        gap: 12px;
                    }

                    .refresh-btn {
                        width: 100%;
                    }

                    .pagination-controls {
                        flex-direction: column;
                        align-items: flex-start;
                        gap: 8px;
                    }
                }
            `}</style>
        </div>
    );
};

export default SubscribeList;